export const HIDE_IN_PROD = window.location.href.includes("b2.pe")